/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useContext } from 'react';

// -----------------LIBRARIES IMPORTS------------------- //
// @ts-ignore
import {
	Button,
	Input,
	Knob,
	ModalConfirmation as Modal,
	ModalConfirmation,
	SideModal,
	Typography,
} from 'design_system/src';

// -----------------DATA IMPORTS------------------- //

import { handleEventGoogle } from 'models/shared/helpers/googleAnalytics';

// -----------------STATIC IMPORTS------------------- //
import '../../../ozoner.scss';
import { ReactComponent as Reload } from 'design_system/src/static/icons/reload.svg';
import { ReactComponent as Fail } from 'design_system/src/static/icons/close-circle.svg';
import { ReactComponent as Success } from 'design_system/src/static/icons/tick-circle.svg';
import { RequireRole } from 'components/layouts/main/sidebar/Sidebar';
import { updateFinancialForm } from 'models/financial-form/controllers/financial-form.controller';
import { FormStatus } from 'models/financial-form/enums/financial-form.enums';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { Roles } from 'models/ozonio/enums/ozonio.enum';
import {
	validationItem,
	validationItemState,
} from 'components/hocs/messages/messages';
import {
	DevolutionAction,
	RejectAction,
	VerifyMonthlyIncomeAction,
} from './SolicitudActions';
import { ozonerContext } from '../../OzonerContext';

function ValidationSection() {
	const [loading, setLoading] = useState(false);
	const { financialForm, ozoner, updateFormData } = useContext(ozonerContext);

	const [loadingTruora, setLoadingTruora] = useState(false);
	const [openRevalidateTruora, setOpenRevalidateTruora] = useState(false);

	// TODO:Terminar truora
	// const validateTruora = () => {
	// 	if (ozoner.truoraId) {
	// 		setOpenRevalidateTruora(true);
	// 	} else {
	// 		handleEventGoogle(
	// 			'BTN_Pb_validate_truora',
	// 			'Panda Solicitudes',
	// 			'click in validate truora button',
	// 		);
	// 		setLoadingTruora(true);
	// 		triggerTruora().then(() => {
	// 			setLoadingTruora(false);
	// 		});
	// 	}
	// };

	const approveSolicitud = () => {
		setLoading(true);
		updateFinancialForm(financialForm.form._id, {
			status: FormStatus.approved,
		})
			.then((newForm) => {
				toasterNotification({
					msg: 'Solicitud Exitosa',
					style: 'light',
					toasterType: toasterOptions.success,
				});
				updateFormData(newForm);
			})
			.catch((err) => {
				commonErrorHandler(err);
			})
			.finally(() => setLoading(false));
		handleEventGoogle(
			'BTN_Pb_request_approve',
			'Panda Solicitudes',
			'click in approve request button',
		);
	};

	return (
		<RequireRole authRoles={[Roles.ADMIN, Roles.CREDIT_ANALYST]}>
			<div
				id="validate-soli-ozoner"
				className="p_md border_b_solid border_1 border_neutral_400 display_flex flex_col flex_gap_md"
			>
				<div className="display_flex flex_col flex_gap_xs">
					<div className="display_flex flex_gap_xs flex_align_center overflow_hidden">
						{validationItem(
							financialForm?.form?.loanApplication?.loanSegmentation
								? validationItemState.valid
								: validationItemState.invalid,
							{
								[validationItemState.valid]: 'Segmentación asignada',
								[validationItemState.invalid]: 'Segmentación sin asignar',
							},
						)}
					</div>
					<div className="display_flex flex_gap_xs flex_align_center overflow_hidden">
						{validationItem(
							financialForm?.form?.financialInformation
								?.monthlyVerifiedIncome !== undefined
								? validationItemState.valid
								: validationItemState.invalid,
							{
								[validationItemState.valid]: 'Ingresos verificados asignados',
								[validationItemState.invalid]:
									'Ingresos verificados sin asignar',
							},
						)}
					</div>
				</div>

				<VerifyMonthlyIncomeAction />
				<Button
					scale="small"
					color="primary"
					onClick={approveSolicitud}
					disabled={
						loading ||
						!financialForm?.form?.loanApplication?.loanSegmentation ||
						financialForm?.form?.financialInformation?.monthlyVerifiedIncome ===
							undefined
					}
				>
					Aprobar
				</Button>
				<DevolutionAction />
				<RejectAction />
			</div>
		</RequireRole>
	);
}
export default ValidationSection;
